module.exports = __webpack_public_path__ + "static/media/Pulse.d58096a3.gif";